var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }